import { StyledBody } from 'baseui/card'
import { ParagraphMedium } from 'baseui/typography'
import IconCarbonLightning from '@/shared/icons/IconCarbonLightning'
import IconCarbonSatelliteRadar from '@/shared/icons/IconCarbonSatelliteRadar'
import IconCarbonRule from '@/shared/icons/IconCarbonRule'
import { FlexGrid, FlexGridItem } from 'baseui/flex-grid'
import SDNotification from '@/shared/components/SDComponents/SDNotification'
import { useTranslation } from 'react-i18next'
import { BlueCard, Card } from '@/shared/theme/styled-components'
import { StyledHeader, StyledTitle } from '@/shared/components/Panel/styled-components'
import useBusinessType from '@/shared/hooks/useBusinessType'

const ErrorPage = ({ currentCountry, currentType, hasErrorType, hasErrorCountry }) => {
  const { t } = useTranslation()
  const { availableVerticals } = useBusinessType({})

  const verticalCards = {
    energie: {
      Icon: IconCarbonLightning,
      titleKey: 'common:energy_title',
      bodyKey: 'common:go_to_energy',
      href: '/energie',
      id: 'button-access-energy',
    },
    telecom: {
      Icon: IconCarbonSatelliteRadar,
      titleKey: 'common:telecom_title',
      bodyKey: 'common:go_to_telecom',
      href: '/telecom',
      id: 'button-access-telecom',
    },
    assurance: {
      Icon: IconCarbonRule,
      titleKey: 'common:insurance_title',
      bodyKey: 'common:go_to_insurance',
      href: '/assurance',
      id: 'button-access-insurance',
    },
  }

  return (
    <main id='main'>
      {hasErrorType && currentType !== '' && (
        <SDNotification type='warning'>{t('common:error_type_access').replace('#TYPE#', currentType)}</SDNotification>
      )}
      {hasErrorCountry && (
        <SDNotification type='warning'>
          {t('common:error_country_access').replace('#COUNTRY#', currentCountry)}
        </SDNotification>
      )}
      <BlueCard>
        {[availableVerticals.slice(0, 2), availableVerticals.slice(2)]
          .filter(pair => pair.length > 0)
          .map((pair, rowIndex) => (
            <FlexGrid
              key={`row-${rowIndex}`}
              flexGridColumnCount={2}
              flexGridColumnGap='scale800'
              flexGridRowGap='scale800'
            >
              {pair.map(vertical => {
                const card = verticalCards[vertical]
                if (!card) return null
                const { Icon, titleKey, bodyKey, href, id } = card
                return (
                  <FlexGridItem key={vertical}>
                    <a href={href} id={id}>
                      <Card>
                        <StyledHeader>
                          <StyledTitle>
                            <Icon size={24} /> {t(titleKey)}
                          </StyledTitle>
                        </StyledHeader>
                        <StyledBody>
                          <ParagraphMedium>{t(bodyKey)}</ParagraphMedium>
                        </StyledBody>
                      </Card>
                    </a>
                  </FlexGridItem>
                )
              })}
            </FlexGrid>
          ))}
      </BlueCard>
    </main>
  )
}

export default ErrorPage
